__turbopack_context__.v({
  "add-to-cart": "RecentlyViewedCarousel-module-scss-module__OqstoW__add-to-cart",
  "carousel-slide": "RecentlyViewedCarousel-module-scss-module__OqstoW__carousel-slide",
  "carousel-slides": "RecentlyViewedCarousel-module-scss-module__OqstoW__carousel-slides",
  "product": "RecentlyViewedCarousel-module-scss-module__OqstoW__product",
  "product-image": "RecentlyViewedCarousel-module-scss-module__OqstoW__product-image",
  "product-image-link": "RecentlyViewedCarousel-module-scss-module__OqstoW__product-image-link",
  "product-info": "RecentlyViewedCarousel-module-scss-module__OqstoW__product-info",
  "product-price": "RecentlyViewedCarousel-module-scss-module__OqstoW__product-price",
  "product-title": "RecentlyViewedCarousel-module-scss-module__OqstoW__product-title",
  "title": "RecentlyViewedCarousel-module-scss-module__OqstoW__title",
});
